import { COLORS } from '../constants/colors';
import { BREAKPOINTS } from '../constants/breakpoints';
import { SPACING } from '../constants/spacing';

// Configuración del tema para styled-components
export const theme = {
  colors: COLORS,
  breakpoints: BREAKPOINTS,
  spacing: SPACING,

  // Fuentes
  fonts: {
    primary: 'Font, sans-serif',
    secondary: 'Anton, sans-serif',
  },

  // Tamaños de fuente
  fontSizes: {
    xs: '10px',
    sm: '14px',
    md: '16px',
    lg: '20px',
    xl: '24px',
    xxl: '32px',
  },

  // Pesos de fuente
  fontWeights: {
    light: 100,
    normal: 400,
    bold: 700,
  },

  // Radios de borde
  borderRadius: {
    sm: '5px',
    md: '10px',
    lg: '25px',
    circle: '50%',
  },

  // Sombras
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
    md: '0 2px 8px rgba(87, 87, 86, 1)',
    lg: '0 4px 8px rgba(0, 0, 0, 0.2)',
    glow: '0 0 10px rgba(255, 255, 255, 0.6)',
    glowLarge: '0 0 30px rgba(255, 255, 255, 0.8)',
  },

  // Transiciones
  transitions: {
    fast: '0.3s',
    medium: '0.4s',
    slow: '0.6s',
  },

  // Z-indexes
  zIndex: {
    base: 1,
    dropdown: 10,
    modal: 100,
    overlay: 999,
    tooltip: 1000,
    top: 1001,
  },
};

export default theme;
